import React, { useState } from "react";
import Navbar from "@/components/campus/Navbar";
import Footer from "@/components/campus/Footer";
import { MessageCircle, Mail, Instagram, Linkedin } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function Contact() {
  const [f, setF] = useState({ full_name:"", email:"", phone:"", message:"" });
  const [sent, setSent] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.message.length < 20) { toast.error("Message must be at least 20 characters"); return; }
    try { await api.submitContact(f); setSent(true); toast.success("Message sent! We'll reply within 24 hours."); }
    catch { toast.error("Failed to send"); }
  };

  return (
    <div className="min-h-screen bg-[#0F172A] text-white">
      <Navbar/>
      <section className="pt-28 px-6 pb-20 max-w-5xl mx-auto">
        <div className="text-center">
          <h1 className="font-display text-4xl md:text-5xl font-bold">Get in Touch</h1>
          <p className="text-slate-400 mt-3">We're here to help — reach us through any of these channels.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4 mt-10">
          <Channel icon={<MessageCircle/>} color="emerald" title="WhatsApp" sub="+91 7980481612" cta="Chat instantly" href="https://wa.me/917980481612"/>
          <Channel icon={<Mail/>} color="blue" title="Email" sub="campussenior.in@gmail.com" cta="Send email" href="mailto:campussenior.in@gmail.com"/>
          <Channel icon={<Instagram/>} color="pink" title="Instagram" sub="@campussenior.in" cta="Follow us" href="https://instagram.com/campussenior.in"/>
          <Channel icon={<Linkedin/>} color="cyan" title="LinkedIn" sub="@campussenior" cta="Connect" href="https://linkedin.com/company/campussenior"/>
        </div>

        <div className="glass rounded-2xl p-7 mt-10 max-w-xl mx-auto">
          {!sent ? (
            <>
              <h3 className="font-display text-xl font-bold mb-4">Send us a message</h3>
              <form onSubmit={submit} className="space-y-3">
                <input required placeholder="Full Name" value={f.full_name} onChange={e=>setF({...f, full_name:e.target.value})} className="w-full bg-[#1E293B] border border-white/10 rounded-lg px-4 py-3"/>
                <input required type="email" placeholder="Email" value={f.email} onChange={e=>setF({...f, email:e.target.value})} className="w-full bg-[#1E293B] border border-white/10 rounded-lg px-4 py-3"/>
                <input placeholder="Phone (optional)" value={f.phone} onChange={e=>setF({...f, phone:e.target.value})} className="w-full bg-[#1E293B] border border-white/10 rounded-lg px-4 py-3"/>
                <textarea required minLength={20} placeholder="Your message (min 20 chars)" value={f.message} onChange={e=>setF({...f, message:e.target.value})} className="w-full bg-[#1E293B] border border-white/10 rounded-lg px-4 py-3 min-h-[120px]"/>
                <button data-testid="contact-submit" className="w-full py-3 rounded-full bg-[#F59E0B] text-[#0F172A] font-bold">Send Message</button>
                <p className="text-xs text-slate-500 text-center">We typically respond within 24 hours via WhatsApp or Email.</p>
              </form>
            </>
          ) : (
            <div className="text-center py-6"><div className="w-16 h-16 rounded-full bg-emerald-500/20 text-emerald-400 mx-auto flex items-center justify-center text-3xl">✓</div><h3 className="font-display text-xl font-bold mt-4">Message sent!</h3><p className="text-slate-400 text-sm mt-2">We'll reply within 24 hours.</p></div>
          )}
        </div>
      </section>
      <Footer/>
    </div>
  );
}

const Channel = ({icon, color, title, sub, cta, href}) => {
  const colors = { emerald:"text-emerald-400 bg-emerald-500/10", blue:"text-blue-400 bg-blue-500/10", pink:"text-pink-400 bg-pink-500/10", cyan:"text-cyan-400 bg-cyan-500/10" };
  return (
    <a href={href} target="_blank" rel="noreferrer" className="glass rounded-2xl p-5 hover:-translate-y-1 transition block">
      <div className={`w-10 h-10 rounded-lg ${colors[color]} flex items-center justify-center mb-3`}>{icon}</div>
      <div className="font-semibold">{title}</div>
      <div className="text-xs text-slate-400 mt-1 truncate">{sub}</div>
      <div className="text-xs text-[#60A5FA] mt-3 font-semibold">{cta} →</div>
    </a>
  );
};
